/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Rep_EmptyInputs */

const en_us2_progress_extra_rep_empty = /** @type {(inputs: Progress_Extra_Rep_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sets with reps in the last few weeks.`)
};

const pt_br2_progress_extra_rep_empty = /** @type {(inputs: Progress_Extra_Rep_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma série com repetições nas últimas semanas.`)
};

const es_419_progress_extra_rep_empty = /** @type {(inputs: Progress_Extra_Rep_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay series con repeticiones en las últimas semanas.`)
};

const pt_pt2_progress_extra_rep_empty = /** @type {(inputs: Progress_Extra_Rep_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma série com repetições nas últimas semanas.`)
};

const fr_fr2_progress_extra_rep_empty = /** @type {(inputs: Progress_Extra_Rep_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune série avec répétitions ces dernières semaines.`)
};

const de_de2_progress_extra_rep_empty = /** @type {(inputs: Progress_Extra_Rep_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Sätze mit Wiederholungen in den letzten Wochen.`)
};

const it_it2_progress_extra_rep_empty = /** @type {(inputs: Progress_Extra_Rep_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna serie con ripetizioni nelle ultime settimane.`)
};

/**
* | output |
* | --- |
* | "No sets with reps in the last few weeks." |
*
* @param {Progress_Extra_Rep_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_rep_empty = /** @type {((inputs?: Progress_Extra_Rep_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Rep_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_rep_empty(inputs)
	if (locale === "es-419") return es_419_progress_extra_rep_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_rep_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_rep_empty(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_rep_empty(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_rep_empty(inputs)
	return en_us2_progress_extra_rep_empty(inputs)
});
export { progress_extra_rep_empty as "progress-extra.rep_empty" }